export * from './baMainMenu.component';
